<template>
  <list-title-bar :titleArray="titleArray"></list-title-bar>
</template>

<script>
import ListTitleBar from "@c/operation-log/common/paging-list/list-title-bar.vue";

export default {
  components: { ListTitleBar },

  computed: {
    titleArray() {
      return [
        { name: "时间", percent: "15%" },
        { name: "消息类型", percent: "15%" },
        { name: "内容", percent: "50%" },
        // { name: "数据类型", percent: "10%" },
        { name: "机构", percent: "20%" },
      ];
    },
  },
};
</script>